import React from "react";

/**
 * Stylised sourcing map (SVG world).
 * Hand-drawn simplified continents — highlights routes from 5 origin countries to India.
 */

const COUNTRIES = [
    { id: "ID", name: "Indonesia", x: 745, y: 305, role: "Steam Coal" },
    { id: "ZA", name: "South Africa", x: 535, y: 365, role: "RB Grades" },
    { id: "AU", name: "Australia", x: 800, y: 380, role: "Premium" },
    { id: "US", name: "USA", x: 215, y: 215, role: "High CV" },
    { id: "RU", name: "Russia", x: 640, y: 165, role: "Kuzbass" },
];

const INDIA = { x: 680, y: 270, name: "INDIA" };

export default function SourcingMap() {
    return (
        <div className="relative w-full" data-testid="sourcing-map">
            <svg
                viewBox="0 0 1000 500"
                className="w-full h-auto"
                xmlns="http://www.w3.org/2000/svg"
            >
                {/* Grid background */}
                <defs>
                    <pattern
                        id="grid"
                        width="40"
                        height="40"
                        patternUnits="userSpaceOnUse"
                    >
                        <path
                            d="M 40 0 L 0 0 0 40"
                            fill="none"
                            stroke="rgba(255,255,255,0.04)"
                            strokeWidth="1"
                        />
                    </pattern>
                    <linearGradient
                        id="routeGrad"
                        x1="0"
                        y1="0"
                        x2="1"
                        y2="0"
                    >
                        <stop offset="0%" stopColor="#FF5722" stopOpacity="0" />
                        <stop offset="50%" stopColor="#FF5722" stopOpacity="0.8" />
                        <stop offset="100%" stopColor="#FF5722" stopOpacity="0.2" />
                    </linearGradient>
                </defs>
                <rect width="1000" height="500" fill="url(#grid)" />

                {/* Continents (simplified outlines) */}
                <g
                    fill="rgba(255,255,255,0.04)"
                    stroke="rgba(255,255,255,0.18)"
                    strokeWidth="1"
                >
                    {/* North America */}
                    <path d="M120,150 L260,140 L290,200 L260,250 L200,280 L150,260 L110,210 Z" />
                    {/* South America */}
                    <path d="M250,290 L300,300 L320,380 L290,440 L260,420 L240,350 Z" />
                    {/* Europe */}
                    <path d="M460,150 L540,140 L560,180 L530,210 L470,200 Z" />
                    {/* Africa */}
                    <path d="M490,220 L580,220 L590,300 L555,380 L520,400 L490,360 L480,290 Z" />
                    {/* Asia */}
                    <path d="M560,140 L820,140 L840,200 L820,260 L740,280 L660,260 L580,220 L560,180 Z" />
                    {/* India bump */}
                    <path d="M660,260 L700,260 L705,310 L680,320 L660,300 Z" />
                    {/* SE Asia / Indonesia */}
                    <path d="M720,300 L800,300 L810,330 L750,340 L720,330 Z" />
                    {/* Australia */}
                    <path d="M760,360 L860,360 L870,410 L820,430 L770,420 Z" />
                </g>

                {/* Routes from origins to India */}
                {COUNTRIES.map((c) => {
                    const mx = (c.x + INDIA.x) / 2;
                    const my = Math.min(c.y, INDIA.y) - 40;
                    return (
                        <path
                            key={`route-${c.id}`}
                            d={`M ${c.x},${c.y} Q ${mx},${my} ${INDIA.x},${INDIA.y}`}
                            fill="none"
                            stroke="url(#routeGrad)"
                            strokeWidth="1.5"
                            strokeDasharray="4 4"
                        />
                    );
                })}

                {/* Origin points */}
                {COUNTRIES.map((c) => (
                    <g key={c.id} data-testid={`map-origin-${c.id}`}>
                        <circle
                            cx={c.x}
                            cy={c.y}
                            r="10"
                            fill="#FF5722"
                            opacity="0.15"
                        />
                        <circle cx={c.x} cy={c.y} r="4" fill="#FF5722" />
                        <text
                            x={c.x + 12}
                            y={c.y + 4}
                            fontFamily="IBM Plex Mono, monospace"
                            fontSize="11"
                            fill="#e4e4e7"
                        >
                            {c.name}
                        </text>
                        <text
                            x={c.x + 12}
                            y={c.y + 18}
                            fontFamily="IBM Plex Mono, monospace"
                            fontSize="9"
                            fill="#71717a"
                        >
                            {c.role}
                        </text>
                    </g>
                ))}

                {/* India destination */}
                <g>
                    <circle
                        cx={INDIA.x}
                        cy={INDIA.y}
                        r="16"
                        fill="#ffffff"
                        opacity="0.08"
                    />
                    <circle
                        cx={INDIA.x}
                        cy={INDIA.y}
                        r="7"
                        fill="#ffffff"
                        stroke="#FF5722"
                        strokeWidth="2"
                    />
                    <text
                        x={INDIA.x - 10}
                        y={INDIA.y - 18}
                        fontFamily="Clash Display, sans-serif"
                        fontSize="14"
                        fontWeight="700"
                        fill="#ffffff"
                    >
                        INDIA
                    </text>
                </g>
            </svg>
        </div>
    );
}
